"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M16.5 7a2.5 2.5 0 00-2.45 2h-2.1a2.5 2.5 0 00-4.9 0h-2.1a2.5 2.5 0 100 1h2.1a2.5 2.5 0 004.9 0h2.1a2.5 2.5 0 102.45-3z"];
//# sourceMappingURL=layout-linear.js.map